import {
  isCensusIntegration,
  isZapierIntegration,
} from '@modules/integrationsV2/utils';
import {
  IntegrationChannelType,
  IntegrationChannelViewFragment,
} from 'generated/graphql';

export const getShouldHideConnectCTA = (
  integrationChannel: IntegrationChannelViewFragment,
) => {
  if (
    integrationChannel.type === IntegrationChannelType.Twitter ||
    integrationChannel.type === IntegrationChannelType.G2
  ) {
    return true;
  }

  return (
    isZapierIntegration(integrationChannel) ||
    isCensusIntegration(integrationChannel)
  );
};
